import { useEffect } from 'react'
import { useAppDispatch } from 'reduxTyped'

import { initializeAvailableFields } from 'common/fields/linking/accountAvailableFields'
import { FilterScenario } from 'common/filter/constants'

interface UseInitializeFields {
  scenario?: FilterScenario
}

export const useInitializeFields = ({ scenario }: UseInitializeFields = {}) => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(initializeAvailableFields({ scenario }))
  }, [dispatch, scenario])
}
